import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Stack,
  Heading,
  Spinner,
  Text,
  Link as ChakraLink,
  Flex,
} from "@chakra-ui/react";
import { Link } from "react-router-dom";
import axios from "axios";
import { getToken } from "utils/auth";
import config from "config";

const Forums = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const fetchPosts = async (page) => {
    try {
      const token = getToken()
      console.log(token)
      setLoading(true);
      const response = await axios.get(`${config.API_URL}/forums/posts?page=${page}`,{
        headers: {
          "Authorization": `Bearer ${token}` // Add the token to the header
        }
      });
      console.log(response)
      const data = response.data;
      setPosts(data.posts); // Assuming backend provides `posts` and `totalPages`
      setTotalPages(data.totalPages);
    } catch (error) {
      console.error("Failed to fetch posts:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPosts(currentPage);
  }, [currentPage]);

  return (
    <Box p={{ base: 3, sm: 6 }}>
      <Heading mb={6} color="teal.500">
        Forums
      </Heading>
      <Button as={Link} to="/txd/forums/create" colorScheme="blue" mb={6} w={{ base: "100%", sm: "auto" }}>
        Create Post
      </Button>
      {loading ? (
        <Flex justify="center" align="center" minH="50vh">
          <Spinner size="xl" color="blue.500" />
        </Flex>
      ) : (
        <Stack spacing={6} minH="50vh">
          {Array.isArray(posts) && posts.length > 0 ? (
            posts.map((post) => (
              <Box
                key={post.ID}
                p={{ base: 4, sm: 6 }}
                borderWidth="1px"
                borderRadius="lg"
                boxShadow="sm"
                _hover={{ shadow: "lg", transform: "scale(1.02)" }}
                transition="all 0.2s"
              >
                <Heading size="md" color="blue.600" mb={2} wordBreak="break-word">
                  <ChakraLink as={Link} to={`/txd/forums/post/${post.ID}`}>
                    {post.title}
                  </ChakraLink>
                </Heading>
                <Text color="gray.600" mb={4}>
                  {post.content?.substring(0, 100)}
                  {post.content?.length >= 100 ? "..." : ""}
                </Text>
                <Flex justify="space-between" align={{ base: "stretch", md: "center" }} direction={{ base: "column", md: "row" }} gap="10px">
                  <Text fontSize="sm" color="gray.500" wordBreak="break-all">
                    Posted by: {post.user?.first_name} ({post.user?.email})
                  </Text>
                  <Button
                    as={Link}
                    to={`/txd/forums/post/${post.ID}`}
                    colorScheme="teal"
                    size="sm"
                    w={{ base: "100%", md: "auto" }}
                  >
                    View Post
                  </Button>
                </Flex>
              </Box>
            ))
          ) : (
            <Text textAlign="center" color="gray.500">
              No posts available.
            </Text>
          )}
        </Stack>
      )}
      <Flex mt={6} justify="space-between" align="center" wrap="wrap" gap="10px">
        <Button
          onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
          isDisabled={currentPage === 1}
          colorScheme="blue"
        >
          Previous
        </Button>
        <Text color="gray.600">
          Page {currentPage} of {totalPages}
        </Text>
        <Button
          onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
          isDisabled={currentPage === totalPages}
          colorScheme="blue"
        >
          Next
        </Button>
      </Flex>
    </Box>
  );
};

export default Forums;
